import { Component, OnInit } from '@angular/core';
import { HttpService } from '../http.service';
declare var google: any;

@Component({
  selector: 'app-driver-map-view',
  templateUrl: './driver-map-view.component.html',
  styleUrls: ['./driver-map-view.component.scss']
})
export class DriverMapViewComponent implements OnInit {
  map;
  mapMarkers: any = [];
  driversList = [];
  geocoder;

  driverDetails = {
    current_address: ''
  };
  constructor(private http: HttpService) { }

  ngOnInit() {
    this.geocoder = new google.maps.Geocoder();
    this.getAllDrivers();
    this.initMap();
  }


  getAllDrivers() {
    this.http.get('driver/get_all_attached').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.driversList = data.data;
        }

      });
  }

  initMap(lat = 12.960691, lng = 77.580116) {
    const marker = {
      latitude: lat,
      longitude: lng
    };
    const mapProp = {
      center: new google.maps.LatLng(lat, lng),
      zoom: 12,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      zoomControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
      }
      // styles: this.mapStyle,
    };

    this.map = new google.maps.Map(document.getElementById('driverMap'), mapProp);

  }

  plotOnMap(driver) {
    this.placeMarker({ latitude: driver.current_location.latitude, longitude: driver.current_location.longitude});


    this.getCurrentAddress(new google.maps.LatLng({ lat: parseFloat(driver.current_location.latitude), lng: parseFloat(driver.current_location.longitude) }));
  }

  placeMarker(location) {
    if (this.mapMarkers.length) {
      this.clearAllMarkers();
    }
    const Icon = {
      url: 'assets/delivery-truck.svg',
      size: new google.maps.Size(100, 60),
      scaledSize: new google.maps.Size(70, 60),
      origin: new google.maps.Point(-15, 0)
    };
    const marker = new google.maps.Marker({
      position: { lat: parseFloat(location.latitude), lng: parseFloat(location.longitude) },
      map: this.map,
      icon: Icon,
      // must use optimized false for CSS
      optimized: false,
      animation: google.maps.Animation.DROP
    });



    this.mapMarkers.push(marker);
    marker.setMap(this.map);
    this.map.setCenter({ lat: parseFloat(location.latitude), lng: parseFloat(location.longitude) });

  }

  getCurrentAddress(request) {
    this.geocoder.geocode({ location: request}, (results, status) => {
      if (status == google.maps.GeocoderStatus.OK) {
        if (results[0] != null) {
          this.driverDetails.current_address = results[0].formatted_address;
        } else {
          alert('No address available');
        }
      }
    });
  }

  clearAllMarkers() {
    this.mapMarkers.forEach(element => element.setMap(null));
    this.mapMarkers.length = 0;
  }

}
